import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'

export const ResourceTypeIconMap = new Map<ResourceType, IconNameType>([
  [ResourceType.Workspace, IconNameType.House],
  [ResourceType.Database, IconNameType.Table],
  [ResourceType.DatabaseProperty, IconNameType.Text],
  [ResourceType.DatabaseView, IconNameType.Grid2],
  [ResourceType.DatabaseSlice, IconNameType.Grid2],
  [ResourceType.DatabaseItem, IconNameType.Database],
  [ResourceType.Dashboard, IconNameType.Grid2],
  [ResourceType.DashboardItem, IconNameType.Grid2],
  [ResourceType.Conversation, IconNameType.CommentLines],
  [ResourceType.DirectConversation, IconNameType.CommentLines],
  [ResourceType.CallRoom, IconNameType.Phone],
  [ResourceType.Automation, IconNameType.Bolt],
  [ResourceType.AutomationVersion, IconNameType.Bolt],
  [ResourceType.AutomationRun, IconNameType.Bolt],
  [ResourceType.Folder, IconNameType.Folder],
  [ResourceType.ResourceSpace, IconNameType.Calendar],
  [ResourceType.ResourceGroup, IconNameType.Folder],
  [ResourceType.ResourceItem, IconNameType.Box],
  [ResourceType.App, IconNameType.Bolt],
  [ResourceType.AppAutomation, IconNameType.Bolt],
  [ResourceType.Connection, IconNameType.Link],
  [ResourceType.ConnectionDefinition, IconNameType.Link],
  [ResourceType.WebhookListener, IconNameType.Link],
  [ResourceType.WebhookListenerDefinition, IconNameType.Link],
  [ResourceType.CloudItem, IconNameType.File],
  [ResourceType.Cron, IconNameType.Clock],
  [ResourceType.Document, IconNameType.File],
  [ResourceType.Whiteboard, IconNameType.PenRuler],
  [ResourceType.Skill, IconNameType.Lightbulb],
  [ResourceType.Agent, IconNameType.Robot],
  [ResourceType.DynamicFieldDefinition, IconNameType.Text],
])
